<template>
  <validation-observer tag="div" ref="form">
    <validation-provider vid="farm_id" :name="lodash.upperFirst($t('harvests.jala_farm'))" rules="required" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('jala_ponds.farm')) + '*'"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <jala-farm-select-ajax
            name="farm_id"
            v-model.number="model.jala_farm_id"
            :disabled="!!model.id"
        ></jala-farm-select-ajax>
      </b-form-group>
    </validation-provider>
    <b-form-group
        v-if="model.jala_farm_id"
        class="row mb-3"
        label-cols-md="2"
    >
      <b-checkbox v-model="useJalaHarvest">{{ lodash.upperFirst($t('harvests.use_jala_harvest')) }}</b-checkbox>
    </b-form-group>
    <validation-provider v-if="model.jala_harvest_id || useJalaHarvest" vid="jala_harvest_id" :name="lodash.upperFirst($t('harvests.jala_harvest'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('harvests.jala_harvest'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <jala-harvest-select-ajax
          :key="`harvests-jala-harvest-jala-farms-${model.jala_farm_id}`"
          name="jala_harvest_id"
          v-model.number="model.jala_harvest_id"
          :selected.sync="jala_harvest"
          :params="{ farm_id__in: model.jala_farm_id }"
          :initial-value="{ farm_id: model.jala_farm_id }"
        ></jala-harvest-select-ajax>
      </b-form-group>
    </validation-provider>
    <template v-if="model.jala_farm_id && !useJalaHarvest">
      <validation-provider vid="harvested_at" :name="lodash.upperFirst($t('harvests.harvested_at'))" rules="required" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.upperFirst($t('harvests.harvested_at')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <date-picker
              name="date"
              type="date"
              format="DD MMMM YYYY"
              :state="errors[0] ? false : (validated ? true : null)"
              v-model="model.harvested_at"
              :disabled="!!model.jala_harvest_id"
          >
          </date-picker>
        </b-form-group>
      </validation-provider>
      <validation-provider vid="weight" :name="lodash.upperFirst($t('harvests.weight'))" rules="required|double|min_value:0.001" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.upperFirst($t('harvests.weight')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <numeral-input
              name="weight"
              :state="errors[0] ? false : (validated ? true : null)"
              v-model.number="model.weight"
              :disabled="!!model.jala_harvest_id"
          ></numeral-input>
        </b-form-group>
      </validation-provider>
      <validation-provider vid="size" :name="lodash.upperFirst($t('harvests.size'))" rules="required|double|min_value:1" v-slot="{ validated, errors }">
        <b-form-group
            class="row mb-3"
            label-cols-md="2"
            :label="lodash.upperFirst($t('harvests.size')) + '*'"
            :state="errors[0] ? false : (validated ? true : null)"
            :invalid-feedback="errors[0]"
        >
          <numeral-input
              name="size"
              :state="errors[0] ? false : (validated ? true : null)"
              v-model.number="model.size"
              :disabled="!!model.jala_harvest_id"
          ></numeral-input>
        </b-form-group>
      </validation-provider>
    </template>
    <validation-provider vid="label" :name="lodash.upperFirst($t('harvests.label'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
          class="row mb-3"
          label-cols-md="2"
          :label="lodash.upperFirst($t('harvests.label'))"
          :state="errors[0] ? false : (validated ? true : null)"
          :invalid-feedback="errors[0]"
      >
        <b-form-input
            name="label"
            type="text"
            :state="errors[0] ? false : (validated ? true : null)"
            v-model="model.label"
        ></b-form-input>
      </b-form-group>
    </validation-provider>
    <hr>
    <validation-provider vid="remark" :name="lodash.upperFirst($t('jala_farms.remark'))" rules="" v-slot="{ validated, errors }">
      <b-form-group
        class="row mb-3"
        :label="lodash.upperFirst($t('jala_farms.remark'))"
        :state="errors[0] ? false : (validated ? true : null)"
        :invalid-feedback="errors[0]"
      >
        <editor
          ref="editor"
          v-if="$parent.$parent.$options.name !== 'BModal'"
          class="form-control"
          :init="editorInit"
          inline
          plugins="lists link image paste help wordcount"
          toolbar="undo redo | styleselect | fontselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent"
          v-model="model.description"
        />
        <b-form-textarea v-else v-model="model.description" />
      </b-form-group>
    </validation-provider>
  </validation-observer>
</template>

<script>
  import FormModel from './model';
  import JalaHarvestSelectAjax from "../inputs/jala-harvest-select-ajax";
  import JalaFarmSelectAjax from "@/components/inputs/jala-farm-select-ajax";

  export default {
    components: {
      JalaFarmSelectAjax,
      JalaHarvestSelectAjax
    },
    extends: FormModel,
    data() {
      return {
        useJalaHarvest: !!(this.value.id && this.value.jala_harvest_id) || !(this.value.id),
        jala_harvest: null,

        model: {
          jala_farm_id: this.$route.query.jala_farm_id,
          jala_harvest_id: this.$route.query.jala_harvest_id,
          ...this.value,
        },
      }
    },
    mounted() {
      //
    },
    watch: {
      'model.jala_harvest_id'(value) {
        if (!value) {
          this.model = {
            ...this.model,
            jala_pond_id: null,
            jala_cycle_id: null,
            jala_harvest_id: null,
            ...(!this.model.id ? {
              harvested_at: null,
              age: null,
              weight: null,
              size: null
            } : {})
          }
        }
      },
      useJalaHarvest(value) {
        if (this.model.id) return;
        if (value) {
          this.model = {
            ...this.model,
            harvested_at: null,
            age: null,
            weight: null,
            size: null
          }
        } else {
          this.model = {
            ...this.model,
            jala_pond_id: null,
            jala_cycle_id: null,
            jala_harvest_id: null,
          }
        }
      },
      jala_harvest(value) {
        if (value) {
          const { harvested_at, age, weight, size, cycle } = value;
          this.model = {
            ...this.model,
            jala_farm_id: cycle.farm_id,
            jala_pond_id: cycle.pond_id,
            jala_cycle_id: value.cycle_id,
            jala_harvest_id: value.id,
            ...{ harvested_at, age, weight, size }
          }
        }
      },
    }
  }
</script>
